import { render } from "./lgu-violation-report.vue?vue&type=template&id=5f2ed132"
import script from "./lgu-violation-report.vue?vue&type=script&lang=js"
export * from "./lgu-violation-report.vue?vue&type=script&lang=js"

import exportComponent from "/home/dev.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__